/**
 * 處理路由頁面切換時，非同步元件載入過渡的處理函式
 * @param {Object} AsyncView 需要載入的元件，如 import('@/components/home/Home.vue')
 * @return {Object} 返回一個promise物件
 */
export default function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    // 需要載入的元件
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@src/views/_loading').default,
    // 展示載入時元件的延時時間。預設值是 200 (毫秒)
    delay: 400,
    // 載入失敗時使用的元件
    error: require('@src/views/_timeout').default,
    // 如果提供了超時時間且元件載入也超時了，
    // 則使用載入失敗時使用的元件。預設值是：`Infinity`
    timeout: 10000,
  });

  return Promise.resolve({
    functional: true,
    render(h, {
      data,
      children
    }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
    .catch((e) => {
      console.log('TCL: View -> error', e);
    });
}
